import NiceModal, { useModal } from '@ebay/nice-modal-react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Modal } from 'baby-design'

export const MarkPurchasedModal = NiceModal.create(() => {
  const modal = useModal()

  const handleClose = () => {
    modal.resolve(undefined)
    modal.hide()
  }

  return (
    <Modal showCloseButton handleClose={handleClose} isOpen={modal.visible}>
      <h1>Mark as purchased</h1>
      <p>Insert mark as purchased modal content here...</p>
    </Modal>
  )
})
